<template>
  <div class="evaluate">
    <van-sticky>
      <van-nav-bar title="评价" left-arrow @click-left="goback()" />
    </van-sticky>

    <!-- 表单 -->
    <van-form
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group :border="false">
        <div class="evaluate_title">请对本次服务进行评价</div>

        <div class="evaluate_rate">
          <van-rate
            class="flex_row jc_center"
            v-model="startValue"
            :size="20"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
            @change="onChange"
          />
          <div class="rate_word">{{ startInfo[startValue].name }}</div>
        </div>

        <van-field
          v-model="submitData.content"
          rows="2"
          autosize
          type="textarea"
          placeholder="请对本次服务进行评价"
          show-word-limit
          :rules="[{ required: true, message: '请填写内容' }]"
        />
      </van-cell-group>

      <van-button
        class="m-t25"
        block
        color="#0CADFC"
        type="info"
        native-type="submit"
        >确认提交</van-button
      >
    </van-form>
  </div>
</template>

<script>
import { Button, NavBar, Sticky, Form, Field, Rate } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Form.name]: Form,
    [Field.name]: Field,
    [Rate.name]: Rate,
  },
  data() {
    return {
      startValue: 5,
      submitData: {
        id: 0,
        stars: 0,
        content: "",
      },
      startInfo: [ 
        { name: "", startValue: 0, value: 0 },
        { name: "极差", startValue: 0, value: 20 },
        { name: "非常差", startValue: 1, value: 40 },
        { name: "还好", startValue: 2, value: 60 },
        { name: "非常好", startValue: 3, value: 80 },
        { name: "极好", startValue: 4, value: 100 },
      ],
    };
  },

  created() {
    this.startName = this.startInfo[this.startValue].name;
    this.submitData.id = this.$route.query.id;
  },

  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onChange(index) {
      this.submitData.stars = this.startInfo[index].value;
    },

    onSubmit() {
      var that = this;
      that.$api
        .orderInfoUserH5AppraiseAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
             that.$router.push({ path: "/order/evaluateFinish" });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.evaluate {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;

  .evaluate_title {
    font-size: 15px;
    padding-top: 50px;
    text-align: center;
  }

  /deep/ .van-field__value {
    background: #f4f3f8;
    padding: 5px;
    height: 150px;
  }

  .evaluate_rate {
    position: relative;
    .van-rate {
      padding: 30px 0px;
    }

    .rate_word {
      position: absolute;
      right: 75px;
      top: 30px;
      font-size: 16px;
    }
  }

  // 表单
  .van-button {
    width: 350px;
    position: fixed;
    bottom: 50px;
    text-align: center;
    left: 0px;
    right: 0px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/evaluate.vue